/**
 * AWS Configuration for Vivah Bandh UI
 * 
 * This file contains all AWS service configurations:
 * - API Gateway endpoint
 * - Cognito User Pool settings
 * - S3 bucket URLs for master data
 */

const awsConfig = {
  // API Gateway
  apiGateway: {
    baseURL: 'https://cxupy5djqa.execute-api.ap-south-1.amazonaws.com/dev',
    region: 'ap-south-1',
    endpoints: {
      // Auth endpoints (public)
      signup: '/api/v1/auth/signup',
      login: '/api/v1/auth/login',
      refresh: '/api/v1/auth/refresh',
      confirmSignup: '/api/v1/auth/confirm-signup',
      resendCode: '/api/v1/auth/resend-code',
      
      // User endpoints (authenticated)
      getCurrentUser: '/api/v1/users/me',
      updateProfile: '/api/v1/users/profile',
      
      // Interest endpoints (authenticated - to be deployed)
      getInterests: '/api/v1/interests',
      sendInterest: '/api/v1/interests',
      updateInterest: '/api/v1/interests',
      
      // Match endpoints (authenticated - to be deployed)
      getMatches: '/api/v1/matches',
      
      // Message endpoints (authenticated - to be deployed)
      getMessages: '/api/v1/messages',
      sendMessage: '/api/v1/messages',
    }
  },

  // Cognito User Pool
  cognito: {
    region: 'ap-south-1',
    userPoolId: 'ap-south-1_lHyS6azdA',
    userPoolClientId: '226g0tlskag4q9hou0tfc79sk8',
    // For token validation
    issuer: 'https://cognito-idp.ap-south-1.amazonaws.com/ap-south-1_lHyS6azdA',
  },

  // Master Data - Loaded from /public/master-data (client-side)
  // No S3 or Lambda costs - pure static file serving
  
  // Environment
  environment: process.env.NODE_ENV || 'development',
  isDevelopment: process.env.NODE_ENV === 'development',
  isProduction: process.env.NODE_ENV === 'production',
};

export default awsConfig;
